import { render } from "./RolesForm.vue?vue&type=template&id=60ede6f6"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__